var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FETCH_TENANT_LIST_REQUEST, fetchTenantListFailure, fetchTenantListSuccess } from "@/redux/actions";
import API from "@/utils/API";
import { call, put, takeLatest } from "redux-saga/effects";
export const onTenantList = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.get(`/onbd/tenant/list?country=${action.payload.country}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchTenantListWorker(action) {
    try {
        const data = yield call(onTenantList, action);
        yield put(fetchTenantListSuccess(data));
    }
    catch (error) {
        yield put(fetchTenantListFailure(error));
    }
}
export function* watchFetchTenantListData() {
    yield takeLatest(FETCH_TENANT_LIST_REQUEST, fetchTenantListWorker);
}
